// Helper function to calculate items per package
export const calculateItemsPerPackage = (sku: any) => {
  if (!sku || !sku.items) return 0;

  const itemsPerPackage = (sku.items || [])
    .map((item: any) => item?.quantity || 0)
    .reduce((acc: number, curr: number) => acc + curr, 0);

  return itemsPerPackage;
};

// Helper function to calculate total items
export const calculateTotalItems = (cases: number, items: number) => {
  if (!cases || !items) return 0;

  const totalItems = cases * items;
  return totalItems;
};
